
import CourseScript from './courseScript'
import { Observer } from 'mobx-vue'
import LazyImg from '@/components/lazyImg/index.vue'
import { Component } from 'vue-property-decorator'

@Observer
@Component({
  name: 'CourseComp',
  components: { LazyImg }
})
export default class CourseComp extends CourseScript {}
